module.exports = __webpack_public_path__ + "img/store_logo_h.851f866d.png";